import React from 'react';

import Radio from '.';
import { Label, TextContent } from './styled';

function LabelRadioComponent({
  checkboxPosition = 'left',
  iconSize = '24px',
  disabled, children,
  ...props
}) {
  return (
    <Label isDisabled={disabled}>
      {checkboxPosition === 'left' && (
        <Radio
          iconSize={iconSize}
          disabled={disabled}
          {...props}
        />
      )}

      <TextContent
        checkboxPosition={checkboxPosition}
        isDisabled={disabled}
      >
        {children}
      </TextContent>

      {checkboxPosition === 'right' && (
        <Radio
          iconSize={iconSize}
          disabled={disabled}
          {...props}
        />
      )}
    </Label>
  );
}

export default LabelRadioComponent;
